<template>
  <div>
    <div class="sayfahead">
      <h1>{{ Sayfa.Adi }}</h1>
      <el-button v-if="Yetki" type="info" size="small" class="YeniBtn" @click="this.YeniBtn">{{ Sayfa.ButtonAdi }}
      </el-button>
    </div>
    <div class="icerik">
      <Yukleniyor :data="lo"></Yukleniyor>
      <div class="ekranbos" v-if="!Liste"></div>
      <el-table
        v-if="Liste"
        :data="Liste.filter(data => !search || data.Konu.toLowerCase().includes(search.toLowerCase()))"
        :height="Height"
        class="golgetable">

        <el-table-column
          label="Tarih Aralığı"
          prop="TarihText"
          width="200">
        </el-table-column>
        <el-table-column
          label="Konu"
          prop="Konu"
          width="200">
        </el-table-column>
        <el-table-column
          label="Bina"
          prop="Bina"
          width="200">
        </el-table-column>
        <el-table-column
          label="İçerik"
          prop="Icerik"
        >
        </el-table-column>
        <el-table-column
          align="right">
          <template slot="header" slot-scope="scope">
            <el-input
              v-model="search"
              size="medium"
              :placeholder="Sayfa.Arama"/>
          </template>
          <template v-if="Yetki" slot-scope="scope">
            <el-button-group>
              <el-tooltip class="item" effect="dark" :content="Sayfa.DuzenleAdi"
                          placement="top-start">
                <i
                  class="feather-edit-2 tableibtn text-primary"
                  @click="DuzenleBtn(scope.row)">
                </i>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" :content="Sayfa.SilAdi"
                          placement="top-start">
                <i
                  class="feather-trash tableibtn text-danger"
                  @click="SilOnay(scope.row.id)">
                </i>
              </el-tooltip>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      v-if="Yetki"
      :title="FormData.Baslik"
      :visible.sync="ModalOlayi"
      center
      width="50%">
      <Yukleniyor :data="lo"></Yukleniyor>
      <a @click="ModalOlayi = false" class="ModalKapat"><i class="el-icon-close"></i></a>
      <el-form :model="FormData" @submit.prevent.native="Submit" :rules="FormHata" ref="Form">
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Konu" prop="Konu">
              <el-input v-model="FormData.Konu"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Site / Bina" prop="Bina_id">
              <el-select v-model="FormData.Bina_id" filterable clearable>
                <el-option-group
                  label="Site Listesi">
                  <el-option
                    v-for="item in Siteler"
                    :key="item.id"
                    :label="item.Adi"
                    :value="item.id">
                  </el-option>
                </el-option-group>
                <el-option-group
                  label="Bina Listesi">
                  <el-option
                    v-for="item in Binalar"
                    :key="item.id"
                    :label="item.Adi"
                    :value="item.id">
                  </el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Tarihi Aralığı" prop="Tarih">
              <el-date-picker
                v-model="FormData.Tarih"
                type="daterange"
                range-separator="-"
                start-placeholder="Başlangıç Tarihi"
                end-placeholder="Bitiş Tarihi"
                format="dd.MM.yyyy"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="İçerik" prop="Icerik">
              <el-input type="textarea" rows="6" resize="none" v-model="FormData.Icerik"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <input type="hidden" v-model="FormData.id">
        <Notlar v-if="FormData.id" :data="{Modul:'Duyuru',Modul_id:FormData.id}"></Notlar>
        <el-alert title="Dosya eklemek için önce kayıt edin."
                  type="success"
                  :closable="false" v-if="!FormData.id"></el-alert>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="medium" @click="Submit()">{{ $t('eGenel.0') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Yukleniyor from "../../components/Doc/Yukleniyor";
import Notlar from "../../components/Pack/Genel/Notlar";

export default {
  components: {Notlar, Yukleniyor},
  data() {
    return {
      lo: false,
      Yetki: false,
      ModalOlayi: false,
      Height: window.innerHeight - 100,
      Sayfa: {
        ButtonAdi: 'Duyuru Ekle',
        Adi: 'Duyurular',
        DuzenleAdi: this.$t('eGenel.10'),
        SilAdi: this.$t('eGenel.11'),
        Arama: this.$t('eGenel.9')
      },
      search: '',
      Liste: null,
      FormData: {
        Konu: null,
        Icerik: null,
        Tarih: [],
        TarihText: null,
        Bina_id: null,
        id: null,
      },
      FormHata: {
        Konu: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Icerik: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Tarih: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],

      },
      Binalar: [],
      Siteler: [],
    }
  },
  methods: {
    SayfaYukle() {
      this.lo = true;
      this.Yetki = this.$store.getters.Yetki.iletisim == 2 ? true : false;
      this.$store.dispatch("Get", {path: 'iletisim/duyuru'})
        .then(response => {
          this.lo = false;
          if (response.Durum === 'OK') {
            this.Liste = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });

    },
    DuzenleBtn(Veri) {

      this.FormData = Veri;
      this.FormData.Tarih = [Veri.basTarih, Veri.bitTarih];
      this.ModalOlayi = true;
      this.FormData.Baslik = 'Duyuru Düzenle'
    },
    YeniBtn() {
      this.ModalOlayi = true;

      this.FormData = {
        Konu: null,
        Icerik: null,
        Tarih: [],
        id: null,
        Baslik: 'Duyuru Ekle'
      }

    },
    Submit() {
      this.$refs['Form'].validate((valid) => {
        if (valid) {
          this.lo = true;
          if (this.FormData.id) {
            // DÜZENLE
            this.$store.dispatch("Put", {
              ...this.FormData,
              path: 'iletisim/duyuru/' + this.FormData.id
            })
              .then(response => {
                this.lo = false;
                if (response.Durum == "OK") {
                  this.ModalOlayi = false;
                  this.$message.success(response.Mesaj);
                  this.SayfaYukle();

                } else {

                  this.$message.error(response.Mesaj);
                  this.hata = response.Hata;

                }
              })

          } else {
            // EKLE
            this.$store.dispatch("Post", {...this.FormData, path: 'iletisim/duyuru'})
              .then(response => {
                this.lo = false;
                if (response.Durum == "OK") {
                  this.ModalOlayi = false;
                  this.$message.success(response.Mesaj);
                  this.SayfaYukle();
                } else {
                  this.$message.error(response.Mesaj);
                  this.hata = response.Hata;
                }
              })
          }
        }
      });
    },
    SilOnay(id) {
      this.$confirm(this.$t('eGenel.1'), this.$t('eGenel.7'), {
        confirmButtonText: this.$t('eGenel.2'),
        cancelButtonText: this.$t('eGenel.3'),
        type: 'warning'
      }).then(() => {
        this.Sil(id)
      }).catch(() => {
        this.$message.info(this.$t('eGenel.8'));
      });
    },
    Sil(id) {
      this.lo = true;
      this.$store.dispatch("Delete", {...this.Form, path: 'iletisim/duyuru/' + id})
        .then(response => {
          this.lo = false;
          if (response.Durum == "OK") {
            this.ModalOlayi = false;
            this.$message.success(response.Mesaj);
            this.SayfaYukle();
          } else {
            this.$message.warning(response.Mesaj);
            this.hata = response.Hata;
          }
        })

    },
  },
  created() {
    this.lo = true;
    this.$store.dispatch("Get", {path: 'yonetim/bina'})
      .then(response => {
        if (response.Durum === 'OK') {
          this.Binalar = response.Liste
        } else {
          this.$message.error(response.Mesaj);
          this.hata = response.Hata;
        }
      });
    this.$store.dispatch("Get", {path: 'yonetim/site'})
      .then(response => {
        this.lo = false;
        if (response.Durum === 'OK') {
          this.Siteler = response.Liste
        } else {
          this.$message.error(response.Mesaj);
          this.hata = response.Hata;
        }
      });
    this.SayfaYukle();

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Iletisim/duyuru.vue